<template>
  <div>
    <span class="counselor-card__availability-date-label"
      >{{ texts.nextAvailable }}:
      <component
        :is="link ? 'a' : 'span'"
        class="counselor-card__availability-date"
        :href="link || null"
        >{{ text }}</component
      >
    </span>
  </div>
</template>

<script>
import { capitalizeFirstLetter } from 'Library/stringFormatHelpers';
import { useTimeSlots } from 'Main/composables/useTimeSlots';

export default {
  name: 'CounselorCardAvailabilityFirstAvailableText',

  setup() {
    const {
      today,
      tomorrow,
      filterTimeSlots,
      generateMeetingTimes,
      formatReadableDate,
    } = useTimeSlots();
    return {
      today,
      tomorrow,
      filterTimeSlots,
      generateMeetingTimes,
      formatReadableDate,
    };
  },

  props: {
    link: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      capitalizeFirstLetter,
      texts: theme_vars.counselorSlider,
    };
  },
};
</script>
